import { EnvObjType } from './obj';
export class FunctionObj {
    constructor(parameters = [], body = null, env = null) {
        this.parameters = parameters;
        this.body = body;
        this.env = env;
    }
    get Parameters() {
        return this.parameters;
    }
    set Parameters(val) {
        this.parameters = val;
    }
    get Body() {
        return this.body;
    }
    set Body(val) {
        this.body = val;
    }
    get Env() {
        return this.env;
    }
    set Env(val) {
        this.env = val;
    }
    Type() {
        return EnvObjType.FUNCTION;
    }
    Inspect() {
        var _a;
        const params = this.parameters.map((p) => p.toString()).join(', ');
        return `fn(${params}) {
            ${(_a = this.body) === null || _a === void 0 ? void 0 : _a.toString()}
        }`;
    }
    toJSON() {
        return "function"; // TODO
    }
    toJS() {
        return () => null; // not sure if we can do this?
    }
    Equals(obj) {
        return obj === this;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnVuY3Rpb25PYmouanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2Vudi9GdW5jdGlvbk9iai50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJQSxPQUFPLEVBQVUsVUFBVSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBRTNDLE1BQU0sT0FBTyxXQUFXO0lBQ3BCLFlBQ1ksYUFBMkIsRUFBRSxFQUM3QixPQUE4QixJQUFJLEVBQ2xDLE1BQTBCLElBQUk7UUFGOUIsZUFBVSxHQUFWLFVBQVUsQ0FBbUI7UUFDN0IsU0FBSSxHQUFKLElBQUksQ0FBOEI7UUFDbEMsUUFBRyxHQUFILEdBQUcsQ0FBMkI7SUFDdkMsQ0FBQztJQUVKLElBQUksVUFBVTtRQUNWLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQztJQUMzQixDQUFDO0lBQ0QsSUFBSSxVQUFVLENBQUMsR0FBRztRQUNkLElBQUksQ0FBQyxVQUFVLEdBQUcsR0FBRyxDQUFDO0lBQzFCLENBQUM7SUFFRCxJQUFJLElBQUk7UUFDSixPQUFPLElBQUksQ0FBQyxJQUFJLENBQUM7SUFDckIsQ0FBQztJQUNELElBQUksSUFBSSxDQUFDLEdBQUc7UUFDUixJQUFJLENBQUMsSUFBSSxHQUFHLEdBQUcsQ0FBQztJQUNwQixDQUFDO0lBRUQsSUFBSSxHQUFHO1FBQ0gsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDO0lBQ3BCLENBQUM7SUFDRCxJQUFJLEdBQUcsQ0FBQyxHQUFHO1FBQ1AsSUFBSSxDQUFDLEdBQUcsR0FBRyxHQUFHLENBQUM7SUFDbkIsQ0FBQztJQUVELElBQUk7UUFDQSxPQUFPLFVBQVUsQ0FBQyxRQUFRLENBQUM7SUFDL0IsQ0FBQztJQUVELE9BQU87O1FBQ0gsTUFBTSxNQUFNLEdBQUcsSUFBSSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUNuRSxPQUFPLE1BQU0sTUFBTTtjQUNiLE1BQUEsSUFBSSxDQUFDLElBQUksMENBQUUsUUFBUSxFQUFFO1VBQ3pCLENBQUM7SUFDUCxDQUFDO0lBRUQsTUFBTTtRQUNGLE9BQU8sVUFBVSxDQUFDLENBQUMsT0FBTztJQUM5QixDQUFDO0lBRUQsSUFBSTtRQUNBLE9BQU8sR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsOEJBQThCO0lBQ3JELENBQUM7SUFFRCxNQUFNLENBQUMsR0FBVztRQUNkLE9BQU8sR0FBRyxLQUFLLElBQUksQ0FBQztJQUN4QixDQUFDO0NBQ0oifQ==